import { activateEhsConfigurationQuery } from "./EhsConfigurationsQueries";
import { PaginationQueryObject, QueryConfig } from "./Queries";

export const getEHSConfigurations = (filter, paginationInput): QueryConfig => {
  const query = `
    query GetEHSConfigurations(filter: $filter, paginationInput: $paginationInput) {
      ehsConfigurations(filter: $filter, paginationInput: $paginationInput) {
        pageInfo {
          totalElements
          hasNext
          hasPrevious
          pageNumber
          pageSize
        }
        items {
          id
          customerId
          configurationType
          description
          version
          active
          dateTimeCreated
          dateTimeUpdated
          createdBy
          updatedBy
        }
      }
    }
  `;

  return {
    query,
    variables: { paginationInput, filter },
  };
};

export const ehsConfigDetailsUpdateMutation = (input): QueryConfig => {
  const query = `mutation handleUpdateEhsConfiguration($input: UpdateEhsConfigInput!){
  updateEhsConfiguration(input: $input){
    id
    customerId
    description
}
  }`;
  return {
    query: query,
    variables: {
      input,
    },
  };
};
